import {
  IQuizStepsHistory,
  QUIZ_STEPS,
} from '@src/interfaces/state.interfaces';

export const NAVIGATION = {
  HOME: '/',
  QUIZ: '/quiz',
  TERMS: '/terms-of-use',
  POLICY: '/privacy-policy',
  PROFILE: '/profile',
  MANAGE_SUBSCRIPTION: '/profile/manage-subscription',
  CANCEL_SUBSCRIPTION: '/profile/manage-subscription/cancel',
  CANCEL_REMINDER_SUBSCRIPTION: '/profile/manage-subscription/cancel-reminder',
  CANCEL_AFTER_FREE_MONTH_SUBSCRIPTION:
    '/profile/manage-subscription/cancel-after-free-month',
  OFFER_SUBSCRIPTION: '/profile/manage-subscription/offer',
  PAUSE_SUBSCRIPTION: '/profile/manage-subscription/pause',
  PROFILE_FASTING_PLANS: '/profile/fasting-plans',
  PROFILE_ONE_FREE_MONTH: '/profile/one-free-month',
  PROFILE_LOGIN_IN_APP: '/profile/login-in-app',
  PAYMENT: '/payment',
  AUTH: '/auth',
  CONTACT: '/contact',
  SURVEY: '/survey',
  LOGIN: '/auth/login',
  RESET_PASSWORD: '/auth/reset-password',
  CREATE_PASSWORD: '/create-password',
  NEW_PASSWORD: '/new-password',
  DOWNLOAD_APP: '/download-app',
  CHECK_PAYMENT: '/check-payment',
  // INFO: Universal / App Link - opens the mobile app, fallback redirects to the store
  APP_LOGIN: '/app/login',

  // INFO: Support old webflow links
  WEBFLOW_CREATE_PASSWORD: '/:id/create-password',
  WEBFLOW_QUIZ: '/:id/quiz',
  WEBFLOW_DOWNLOAD_APP: '/:id/download-app',
  WEBFLOW_CANCEL_SUBSCRIPTION: '/:id/cancel-subscription',
  WEBFLOW_RESET_PASSWORD: '/:id/reset-password',
  WEBFLOW_NEW_PASSWORD: '/:id/new-password',
  WEBFLOW_PAYMENT: '/:id/final',
  WEBFLOW_PAYMENT_EXPIRED: '/:id/final-expired',
  WEBFLOW_HOME: '/:id/intro',
  WEBFLOW_PROFILE: '/:id/my-account',
  WEBFLOW_MANAGE_SUBSCRIPTION: '/:id/manage-subscription',
} as const;

export const SEARCH_KEYS = {
  TOKEN: 'token',
  EMAIL: 'email',
  PERMANENT_INTENT: 'payment_intent',
  REDIRECT_STATUS: 'redirect_status',
  PLAN_ID: 'planID',
  OFFER_CODE: 'offer_code',
  APP_LOGIN_TOKEN: 'token',
  VARIANT: 'variant',
} as const;

export const QUIZ_STEPS_HISTORY: IQuizStepsHistory = [
  {
    step: QUIZ_STEPS.INTERMITTENT_FASTING,
    registrationFields: [QUIZ_STEPS.INTERMITTENT_FASTING],
  },
  { step: QUIZ_STEPS.ACHIEVE },
  { step: QUIZ_STEPS.GENDER, registrationFields: [QUIZ_STEPS.GENDER] },
  { step: QUIZ_STEPS.USERS, isSocial: true },
  { step: QUIZ_STEPS.CURRENT_BODY_TYPE },
  { step: QUIZ_STEPS.IDEAL_BODY_TYPE },
  { step: QUIZ_STEPS.VITAL_BENEFITS, isSocial: true },
  { step: QUIZ_STEPS.LAST_HAPPY },
  {
    step: QUIZ_STEPS.FEEL_HUNGRY,
    registrationFields: [QUIZ_STEPS.FEEL_HUNGRY],
  },
  {
    step: QUIZ_STEPS.TIME_BREAKFAST,
    registrationFields: [QUIZ_STEPS.TIME_BREAKFAST],
  },
  { step: QUIZ_STEPS.TIME_LUNCH, registrationFields: [QUIZ_STEPS.TIME_LUNCH] },
  {
    step: QUIZ_STEPS.TIME_DINNER,
    registrationFields: [QUIZ_STEPS.TIME_DINNER],
  },
  { step: QUIZ_STEPS.PREPARE_MEALS },
  {
    step: QUIZ_STEPS.FASTING_WEEKENDS,
    registrationFields: [QUIZ_STEPS.FASTING_WEEKENDS],
  },
  { step: QUIZ_STEPS.DIETARY_PATTERN },
  { step: QUIZ_STEPS.SUSTAINABLE_WEIGHT_LOSS, isSocial: true },
  { step: QUIZ_STEPS.SLEEP, registrationFields: [QUIZ_STEPS.SLEEP] },
  {
    step: QUIZ_STEPS.PHYSICALLY_ACTIVE,
    registrationFields: [QUIZ_STEPS.PHYSICALLY_ACTIVE],
  },
  { step: QUIZ_STEPS.AREAS, isSocial: true },
  {
    step: QUIZ_STEPS.WORKING_HOURS,
    registrationFields: [QUIZ_STEPS.WORKING_HOURS],
  },
  { step: QUIZ_STEPS.STAIRS_BREATH },
  { step: QUIZ_STEPS.WALKING_TYPICAL_DAY },
  { step: QUIZ_STEPS.LOSE_TWICE, isSocial: true },
  { step: QUIZ_STEPS.DAILY_MEALS },
  { step: QUIZ_STEPS.DRINK_WATER },
  { step: QUIZ_STEPS.BAD_HABITS },
  { step: QUIZ_STEPS.LIFESTYLE },
  { step: QUIZ_STEPS.ACHIEVE_YOUR_TARGET_WEIGHT },
  { step: QUIZ_STEPS.RESTRICTIVE_DIETS, isSocial: true },
  { step: QUIZ_STEPS.HEIGHT, registrationFields: [QUIZ_STEPS.HEIGHT] },
  {
    step: QUIZ_STEPS.CURRENT_WEIGHT,
    registrationFields: [QUIZ_STEPS.CURRENT_WEIGHT, 'profile.weight.current'],
  },
  {
    step: QUIZ_STEPS.TARGET_WEIGHT,
    registrationFields: [QUIZ_STEPS.TARGET_WEIGHT],
  },
  { step: QUIZ_STEPS.YOUR_AGE, registrationFields: [QUIZ_STEPS.YOUR_AGE] },
  { step: QUIZ_STEPS.WELLNESS, isSocial: true },
  { step: QUIZ_STEPS.LOSE_WEIGHT_FOR },
  { step: QUIZ_STEPS.EVENT_DATE, isSocial: true },
  { step: QUIZ_STEPS.GRAPH, isSocial: true },
  { step: QUIZ_STEPS.PLAN, isSocial: true },
  { step: QUIZ_STEPS.YOUR_WEIGHT_GRAPH, isSocial: true },
  {
    step: QUIZ_STEPS.EMAIL,
    registrationFields: [QUIZ_STEPS.EMAIL],
    isSocial: true,
  },
  { step: QUIZ_STEPS.RECEIVE_EMAILS, isSocial: true },
  { step: QUIZ_STEPS.NAME, isSocial: true },
  { step: QUIZ_STEPS.SPECIAL_DISCOUNT, isSocial: true },
  { step: QUIZ_STEPS.PROGRESS_TEASER, isSocial: true },
];

export const TOTAL_STEPS = QUIZ_STEPS_HISTORY.filter(
  ({ step }) => step !== QUIZ_STEPS.PROGRESS_TEASER,
).length;

export const footerNavLinks = (isLogged?: boolean) => [
  isLogged
    ? {
        link: NAVIGATION.PROFILE,
        title: 'footer.мyAccount',
      }
    : {
        link: NAVIGATION.LOGIN,
        title: 'footer.login',
      },
  { link: NAVIGATION.POLICY, title: 'homePage.terms.policy' },
  { link: NAVIGATION.TERMS, title: 'homePage.terms.title' },
  { link: NAVIGATION.CONTACT, title: 'footer.contact' },
];

export const EXTERNAL_LINKS = {
  TRUSTPILOT: 'https://link.fitfast.com/review',
  HELP_CENTER: 'https://help.fitfast.com/hc/en-us',
  HELP_CENTER_REQUEST: 'https://help.fitfast.com/hc/en-us/requests/new',
};
